var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "search",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.6L12.5 12c.8-.9 1.3-2.1 1.3-3.4 0-2.8-2.2-5.1-4.9-5.1S4 5.8 4 8.6s2.2 5.1 4.9 5.1c1 0 1.9-.3 2.7-.8l3.5 3.6.9-.9zm-7.1-3.2c-2 0-3.7-1.7-3.7-3.8s1.7-3.8 3.7-3.8 3.7 1.7 3.7 3.8-1.6 3.8-3.7 3.8z"
  })));
};

export default SvgSearch;